import React from 'react';

const systemStatusTab = (props) => (
    <React.Fragment>
        <div id={`tab_${props.tabKey}`} className={'tab' + (props.selected ? ' selected' : '')} onClick={props.click}>
            <img src={props.icon} alt="" />
            <span>{props.title}</span>
            {props.showErrorDot && <span className={'red-alert-dot alert-dot small-alert-dot'}></span>}
            {props.showWarningDot && <span className={'orange-alert-dot alert-dot small-alert-dot'}></span>}
        </div>
    </React.Fragment>
);

export default systemStatusTab;
